module.exports = __webpack_public_path__ + "static/ad08c3f3e9ad86ebf5cefbdc9fad092890b0ea024e8e8a3456c8b4c0bc8e057d-e7b7ee8bae1d2666aac263a37df1e556.png";